import styled from '@emotion/styled';
import React from 'react';
import { InfoFoundSelectAll } from './InfoFoundSelectAll';
import { InfoFoundRadio } from './InfoFoundRadio';
import { INameSearchName } from 'components/forms/NameSearchUploadAttachments/types';

interface Name {
  name: string;
  id: number;
  infoFound: boolean;
  childSupportInfoFound?: boolean;
}

const Header = styled.h3`
  font-weight: bold;
  margin-bottom: 8px;
`;

const DocumentIndicator = styled.span`
  color: #28a745;
  font-size: 16px;
  font-weight: bold;
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
`;

interface PropTypes {
  headerText: string;
  foundKey?: 'infoFound' | 'childSupportInfoFound';
  names: INameSearchName[];
  onAllYesCheck: () => void;
  onAllNoCheck: () => void;
  onChangeYes: (n: Name) => void;
  onChangeNo: (n: Name) => void;
}

export const InfoFoundSection = (props: PropTypes) => {
  const foundKey = props.foundKey || 'infoFound';
  return (
    <div style={{ marginTop: 20 }}>
      <Header>{props.headerText}</Header>
      {props.names.length > 1 && (
        <div style={{ display: 'flex', marginBottom: 8 }}>
          <InfoFoundSelectAll
            allYesChecked={props.names.every(p => p[foundKey])}
            allNoChecked={!props.names.find(p => p[foundKey])}
            onAllYesCheck={props.onAllYesCheck}
            onAllNoCheck={props.onAllNoCheck}
          />
        </div>
      )}
      {props.names.map(n => {
        return (
          <div key={n.id} style={{ display: 'flex', alignItems: 'flex-start' }}>
            <InfoFoundRadio
              label={n.name}
              checked={!!n[foundKey]}
              onChangeYes={() => props.onChangeYes(n)}
              onChangeNo={() => props.onChangeNo(n)}
            />
            {n.uploadedDocuments && (
              <DocumentIndicator title="Document uploaded">✓</DocumentIndicator>
            )}
          </div>
        );
      })}
    </div>
  );
};
